@if (marker()) {
  @if (marker().type === cvMarkerType.GROUP) {
    <div class="flex flex-col max-h-[300px]">

      @for (m of marker().overlappingMarkers; track m.id) {
        <div class="flex flex-col">
          <div class="flex justify-start my-2">
            <img alt="marker pin"
                 height="40"
                 [style.opacity]="m.type === cvMarkerType.HISTORY ? 0.7 : 1"
                 [src]="getCvMarkerUrl(
                  m.type === cvMarkerType.HISTORY ? getHistoryItem(m.id)?.source : m.type,
                  isVerifiedMarker(m.id),
                false)">

            <div class="flex flex-col items-start ml-4">
              <ng-template [ngTemplateOutlet]="button"
                           [ngTemplateOutletContext]="{ item: m }"></ng-template>
              @if (m.type === cvMarkerType.HISTORY || (isVerifiedMarker(m.id)
                  && lastValidation())) {
                <span>{{
                    'Val: ' + (getTimestamp(m) | date:'dd.MM.yyyy, HH:mm')
                  }}</span>
              }
            </div>
          </div>

          <mat-divider class="w-full"/>
        </div>
      }
    </div>
  } @else {
    <ng-template [ngTemplateOutlet]="button"
                 [ngTemplateOutletContext]="{ item: marker() }"/>
  }
}


<ng-template #button let-data="item">
  <button mat-flat-button
          class="mb-1"
          (click)="processMarkerAction.emit(data)"
          [class.bg-red-50]="determineMarkerAction(data, focusedLocation().verified) === cvMarkerAction.INVALIDATE">
    {{ determineMarkerAction(data, focusedLocation().verified) }}
  </button>
</ng-template>

